import React, { useEffect, useState } from 'react'
import MobileFilterSheet from './mobileFilterSheet'

/**
 * Default/empty state for the shift filter fields, mirroring the fields used
 * by the desktop WorkShiftsSearch component (from/to/permitNumber/driverNumber).
 * shiftNumber is intentionally left out here: on mobile it's already covered
 * by the free-text search box in the header.
 */
export const defaultShiftsFilters = {
   from: '',
   to: '',
   permitNumber: '',
   driverNumber: ''
}

const inputClass = 'w-full text-sm md:text-base bg-white border border-gray-300 rounded-lg px-3 py-2 md:py-2.5 outline-none focus:border-blue-500'
const inputStyle = { backgroundColor: '#ffffff' }
const labelClass = 'text-sm md:text-base font-medium text-gray-600 block mb-1'

/**
 * Mobile equivalent of components/workShifts/workShiftsSearch.js, presented
 * as a bottom sheet. Keeps its own draft state so edits aren't applied until
 * "Søk" is pressed, and resets/re-searches immediately on "Nullstill",
 * matching the desktop reset/search behaviour.
 */
const MobileShiftsFilter = ({ open, onClose, values, onApply }) => {
   const [draft, setDraft] = useState(values)

   useEffect(() => {
      if (open) setDraft(values)
   }, [open, values])

   const handleChange = e => {
      const { name, value } = e.target
      setDraft(draft => ({ ...draft, [name]: value }))
   }

   const handleSearch = () => {
      onApply(draft)
      onClose()
   }

   const handleReset = () => {
      setDraft(defaultShiftsFilters)
      onApply(defaultShiftsFilters)
      onClose()
   }

   return (
      <MobileFilterSheet open={open} title="Filtrer skift" onClose={onClose} onReset={handleReset} onSearch={handleSearch}>
         <div className="grid grid-cols-2 gap-3">
            <div>
               <label className={labelClass}>Fra</label>
               <input
                  type="datetime-local"
                  name="from"
                  value={draft.from}
                  onChange={handleChange}
                  min="2018-06-07T00:00"
                  max="2040-06-14T00:00"
                  className={inputClass}
                  style={inputStyle}
               />
            </div>
            <div>
               <label className={labelClass}>Til</label>
               <input
                  type="datetime-local"
                  name="to"
                  value={draft.to}
                  onChange={handleChange}
                  min="2018-06-07T00:00"
                  max="2040-06-14T00:00"
                  className={inputClass}
                  style={inputStyle}
               />
            </div>
         </div>
         <div>
            <label className={labelClass}>Løyve</label>
            <input type="text" name="permitNumber" value={draft.permitNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Sjåførnummer</label>
            <input type="number" name="driverNumber" value={draft.driverNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
      </MobileFilterSheet>
   )
}

export default MobileShiftsFilter
